<template>
	<v-card outlined class="section-card" :class="{ 'section-card--flat': flat }">
		<div class="section-card-head">
			<v-icon v-if="icon" small class="section-card-icon">{{ icon }}</v-icon>
			<span class="section-card-title">{{ title }}</span>
			<span v-if="subtitle" class="section-card-subtitle">· {{ subtitle }}</span>
			<v-spacer></v-spacer>
			<slot name="actions"></slot>
		</div>
		<div class="section-card-body" :class="{ 'pa-0': noPadding }">
			<slot></slot>
		</div>
	</v-card>
</template>

<script>
// card di una sezione della scheda ordine: intestazione con icona, titolo e azioni della sezione
export default {
	name: 'SectionCard',
	props: {
		title: { type: String, required: true },
		icon: { type: String, default: '' },
		subtitle: { type: String, default: '' },
		noPadding: { type: Boolean, default: false },
		flat: { type: Boolean, default: false },
	},
};
</script>

<style scoped>
.section-card {
	border-radius: 10px !important;
	overflow: hidden;
	height: 100%;
}
.section-card-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	min-height: 44px;
	padding: 6px 12px;
	background: #f3f6fa;
	border-bottom: 1px solid #e1e7ef;
}
.section-card-icon {
	color: #01579b !important;
}
.section-card-title {
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.section-card-subtitle {
	font-size: 12px;
	color: #5f6b7a;
}
.section-card-body {
	padding: 12px 16px 16px;
}
</style>
